export type CodeValidationResult = {
  stdin: string | null;
  stdout: string;
  time: string;
  memory: number;
  stderr: string | null;
  token: string | null;
  compileOutput: string | null;
  message: string | null;
  expectedOutput: string | null;
  status: {
    id: number;
    description: CodeValidationResultEnum;
  };
};

export enum CodeValidationResultEnum {
  WRONG_ANSWER = 'Wrong Answer',
  ACCEPTED = 'Accepted',
}
